import { Input, Table, Tag } from 'antd';
import { DEBOUNCE_TIME, PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import React from 'react';
import { debounce, truncateString } from 'utils';
import { TableSearchPanel } from 'ui/TableSearchPanel';
import { SearchOutlined } from '@ant-design/icons';

function BVUTable({
  items,
  loading,
  current,
  pageSize,
  total,
  onRowClick,
  onFilter,
  onChange,
}) {
  const columns = [
    {
      title: 'Swift БИК',
      dataIndex: 'bik',
      key: 'bik',
    },
    {
      title: 'Наименование',
      dataIndex: 'name',
      key: 'name',
      render: (name) => (name ? truncateString(name, 25) : '---'),
      filterDropdown: () => {
        return (
          <TableSearchPanel>
            <Input
              allowClear
              autoFocus
              type="text"
              placeholder="Поиск по названию"
              onChange={debounce(
                (e) => onFilter({ bank_name: e.target.value }),
                DEBOUNCE_TIME
              )}
            />
          </TableSearchPanel>
        );
      },
      filterIcon: () => <SearchOutlined />,
    },
    {
      title: 'Код банка',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'Город',
      dataIndex: 'city',
      key: 'city',
    },
    {
      title: 'Избранный',
      dataIndex: 'favorite',
      key: 'favorite',
      render: (isFav) => {
        return (
          <Tag color={isFav ? 'green' : 'red'}>{isFav ? 'Да' : 'Нет'}</Tag>
        );
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      scroll={{ y: SCROLL_Y }}
      pagination={{
        total,
        current,
        pageSize,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { BVUTable };
